import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddPortfolioSchema, IPortfolio, IPortfolioState } from './types';

const initialState: IPortfolioState = {
  addPortfolio: {},
  portfolio: {},
  deletePortfolio: {},
  updatePortfolio: {},
};
const slice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    addPortfolio(state, action: PayloadAction<IAddPortfolioSchema>) {
      state.addPortfolio.status = RequestStatus.RUNNING;
    },
    addPortfolioSuccess(state, action: PayloadAction<IAddPortfolioSchema>) {
      state.addPortfolio.status = RequestStatus.SUCCESS;
      state.addPortfolio.data = action.payload;
    },
    addPortfolioFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addPortfolio.status = RequestStatus.ERROR;
      state.addPortfolio.error = action.payload;
    },
    //
    getPortfolio(state) {
      state.portfolio.status = RequestStatus.RUNNING;
    },
    getPortfolioSuccess(state, action: PayloadAction<IPortfolioState['portfolio']['data']>) {
      state.portfolio.status = RequestStatus.SUCCESS;
      state.portfolio.data = action.payload;
    },
    getPortfolioFailed(state, action: PayloadAction<IRequestFailed>) {
      state.portfolio.status = RequestStatus.ERROR;
      state.portfolio.error = action.payload;
    },

    //
    deletePortfolio(state, action: PayloadAction<{ id: number }>) {
      state.deletePortfolio.status = RequestStatus.RUNNING;
    },
    deletePortfolioSuccess(state) {
      state.deletePortfolio.status = RequestStatus.SUCCESS;
    },
    deletePortfolioFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deletePortfolio.status = RequestStatus.ERROR;
      state.deletePortfolio.error = action.payload;
    },

    //
    updatePortfolio(state, action: PayloadAction<any>) {
      state.updatePortfolio.status = RequestStatus.RUNNING;
    },
    updatePortfolioSuccess(state, action: PayloadAction<IPortfolio>) {
      state.updatePortfolio.status = RequestStatus.SUCCESS;
      state.updatePortfolio.data = action.payload;
    },
    updatePortfolioFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updatePortfolio.status = RequestStatus.ERROR;
      state.updatePortfolio.error = action.payload;
    },
    //
  },
});

export default slice.reducer;
export const {
  addPortfolio,
  addPortfolioSuccess,
  addPortfolioFailed,
  getPortfolio,
  getPortfolioFailed,
  getPortfolioSuccess,
  deletePortfolio,
  deletePortfolioSuccess,
  deletePortfolioFailed,
  updatePortfolio,
  updatePortfolioSuccess,
  updatePortfolioFailed,
} = slice.actions;
